module.exports = {"links":{"help_page":"http://foresight.help.ffm.vic.gov.au","feedback_email":"foresight@delwp.vic.gov.au","support_page":"https://servicedesk.ffm.vic.gov.au/servicedesk/customer/portal/4"},"google_anaylitics":{"tracking_id":"UA-132312929-1","pageview":"/foresight"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/app_settings.json
// module id = 274
// module chunks = 0